import {
	MimaButton,
	MimaInput,
	MimaText,
	Modal,
	AppPage,
} from '../../components';
import { NewReceiptContainer, ReceiptSummaryContainer } from '../../containers';
import styles from '../../assets/styles/Receipt/Receipt.module.scss';
import { BsFilterLeft, BsThreeDotsVertical } from 'react-icons/bs';
import { amountFormatter } from '../../utils/utils';
import { AnimatePresence } from 'framer-motion';
import moment from 'moment';
import React from 'react';
const Receipt = ({
	receiptDetails,
	goToNewReceipt,
	addNewReceipt,
	closeModal,
	viewReceiptModal,
	goToViewReceipt,
}) => {
	return (
		<AppPage pageTitle="Receipt">
			<div>
				<div className={styles.upper}>
					<div className={styles.upper__icon}>
						<BsFilterLeft />
					</div>
					<div className={styles.upper__search}>
						<MimaInput variant="wide" placeholder="search" />
					</div>
					<MimaButton
						title="+ Create Receipt"
						width={20}
						onClick={goToNewReceipt}
					/>
				</div>
				<div className={styles.receipt__list}>
					<table className={styles.table}>
						<thead>
							<tr>
								<th> ID </th>
								<th> Date Created</th>
								<th> Customer </th>
								<th> Service </th>
								<th> Amount </th>
							</tr>
						</thead>
						<tbody>
							{receiptDetails.map(value => (
								<tr onClick={goToViewReceipt} key={value._id}>
									<td> {value.number} </td>
									<td> {moment(value.dueDate).format('DD/MM/YYYY')} </td>
									<td> {value.customer[0].fullname} </td>
									<td> change service samuel </td>
									<td> {amountFormatter().format(value.subAmount)} </td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			{(addNewReceipt || viewReceiptModal) && (
				<div className={styles.modal}>
					<AnimatePresence>
						{addNewReceipt && <NewReceiptContainer closeModal={closeModal} />}
						{viewReceiptModal && (
							<Modal closeModal={closeModal}>
								<ReceiptSummaryContainer />
							</Modal>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Receipt;
